import { useNavigate } from "react-router-dom";
import { ASSETS_URL } from "../util/constants";

const UserInformation = ({
  user,
  visitor,
}: {
  user: any;
  visitor: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <div className="profile-user-card">
      <img
        src={`${ASSETS_URL}/avatar/collector.png`}
        alt="Profile"
        className="profile-avatar-image"
      />
      <div className="profile-user-main">
        { user.pokemonGoProfile.team.name !== "Harmony" &&
          <img
            src={`${visitor ? ".." : "."}/assets/${user.pokemonGoProfile.team?.pathImage}`}
            alt={user.pokemonGoProfile.team?.name}
            className="profile-team-icon"
          />
        }
        <div>
          <div className="profile-name-row">
            <img
              src={`${visitor ? ".." : "."}/assets/${user.country?.pathImage}`}
              alt="Country Flag"
              className="profile-country-flag"
            />
            <h2>{user.username}</h2>
          </div>
          <p className="profile-level">{`Lv. ${user.pokemonGoProfile?.level}`}</p>
        </div>
      </div>

      {!visitor && (
        <button
          className="profile-edit-button"
          onClick={() => {
            navigate("/profile/edit");
          }}
        >
          Edit Profile
        </button>
      )}
    </div>
  );
};

export default UserInformation;
